import TrancheSizeCell from './TrancheSizeCell';

export default TrancheSizeCell;
